import React from "react";
import { Link, useLocation } from 'react-router-dom';

type TabItem = {
  icon: string;
  label: string;
  path: string;
  active?: boolean;
};

interface TabBarProps {
  className?: string;
}

export const TabBar: React.FC<TabBarProps> = ({ className }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  const tabs: TabItem[] = [
    { 
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/a8f50082a07ac81b69a97f6ef39aabf103003fd0", 
      label: "Home", 
      path: "/dashboard",
      active: currentPath === "/dashboard" || currentPath === "/" 
    },
    { 
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/aa98cc873d35bf1251bcc106c5e32dda3ff9420d", 
      label: "Usage", 
      path: "/usage",
      active: currentPath === "/usage" || currentPath === "/usage-tracker" || currentPath.includes("/analytics") 
    },
    { 
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/0bec987a4d07f21dfc643e475c2da92b1ad8ace3", 
      label: "Top up", 
      path: "/top-up",
      active: currentPath === "/top-up" || currentPath === "/make-payment" || currentPath === "/change-plan" 
    },
    { 
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/ffa34392a334b9d3fcaa68ab33d0210b50722be2", 
      label: "Settings", 
      path: "/settings",
      active: currentPath === "/settings" || currentPath === "/profile" 
    },
  ];

  return (
    <nav className={`z-10 w-full fixed bottom-0 left-0 right-0 ${className || ""}`}>
      <div className="w-full">
        <div className="pb-4 w-full bg-white bg-opacity-60 backdrop-blur-lg backdrop-filter border-t border-gray-200 shadow-sm">
          <div className="flex justify-between items-start px-6 mt-2 w-full max-w-[480px] mx-auto">
            {tabs.map((tab, index) => (
              <Link 
                key={index}
                to={tab.path}
                className="flex flex-col items-center w-16 group"
                aria-current={tab.active ? 'page' : undefined}
              >
                <div className="flex justify-center w-full">
                  <div
                    className={`flex overflow-hidden justify-center items-center p-2 w-10 h-full ${
                      tab.active 
                        ? "bg-blue-50 ring-2 ring-blue-100" 
                        : "bg-white hover:bg-gray-50 transition-colors"
                    } rounded-md`}
                  >
                    <img
                      src={tab.icon}
                      className={`object-contain self-stretch my-auto w-5 aspect-square ${
                        tab.active ? "opacity-100" : "opacity-70"
                      }`}
                      alt={`${tab.label} icon`}
                    />
                  </div>
                </div>
                <span
                  className={`text-xs mt-1.5 ${
                    tab.active
                      ? "font-medium text-center text-blue-600"
                      : "text-center text-gray-500 group-hover:text-gray-700 transition-colors"
                  }`}
                >
                  {tab.label}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};
